






import { Component, Prop, Vue } from 'vue-property-decorator';
import Bar from '@/components/Bar.vue'
import firebase from 'firebase/app';

import 'firebase/auth';
import 'firebase/database';
import 'firebase/firestore';

const app = firebase.initializeApp({
  apiKey: "AIzaSyBhdBaFLI6F34AB49bhwo8EBmZjzO4zfcc",
  authDomain: "rss-koncept.firebaseapp.com",
  databaseURL: "https://rss-koncept.firebaseio.com",
  projectId: "rss-koncept",
  storageBucket: "rss-koncept.appspot.com",
  messagingSenderId: "345877032657",
  appId: "1:345877032657:web:117240f9423e0099fc1ff0",
  measurementId: "G-5BYFX0GMDP"
});


@Component({
  name: 'App',
  components: {
    Bar
  }
})
export default class App extends Vue {

}
